<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M44.1,6.2H5.9c-1.9,0-3.5,1.6-3.5,3.5v30.5c0,1.9,1.6,3.5,3.5,3.5h38.2c1.9,0,3.5-1.6,3.5-3.5V9.7c0-1.9-1.6-3.5-3.5-3.5ZM44.6,9.7v8h-18.2v-8.5h17.7c.3,0,.5.2.5.5ZM26.5,20.7h18.2v8.5h-18.2v-8.5ZM23.5,29.3H5.4v-8.5h18.1v8.5ZM5.9,9.2h17.6v8.5H5.4v-8c0-.3.2-.5.5-.5ZM5.4,40.3v-8h18.1v8.5H5.9c-.3,0-.5-.2-.5-.5ZM44.1,40.8h-17.7v-8.5h18.2v8c0,.3-.2.5-.5.5Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>